import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, footerLinks } from '../data/mock';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#333333] py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Home Link */}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_af379c3c-fcd6-4194-be29-caf51021bd6a/artifacts/tv2sat07_Logo.png"
                alt="Agri Direct Australia"
                className="h-14"
              />
            </Link>
            <Link 
              to="/contact" 
              className="text-white/80 hover:text-white transition-colors text-sm"
            >
              Contact Us
            </Link>
          </div>

          {/* Useful Links */}
          <div className="md:col-span-2">
            <h4 className="text-white font-semibold mb-4">Useful Links</h4>
            <ul className="space-y-2">
              {footerLinks.usefulLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/80 hover:text-white transition-colors text-sm flex items-center gap-1"
                  >
                    {link.name}
                    <ExternalLink size={12} />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Pulse Australia Membership */}
          <div className="flex flex-col items-start">
            <h4 className="text-white font-semibold mb-4">Membership</h4>
            <a
              href={footerLinks.pulseAustralia.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-start gap-2"
            >
              <img
                src={footerLinks.pulseAustralia.logo}
                alt="Pulse Australia"
                className="h-12 bg-white p-2 rounded"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <p className="text-white/80 text-xs">
                {footerLinks.pulseAustralia.memberText}
              </p>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 pt-4">
          <p className="text-white/60 text-sm text-center">
            {companyInfo.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
